<template>
  <div class="lp" role="radiogroup" :aria-label="label">
    <button v-for="item in items" :key="item.key" type="button" role="radio" :aria-checked="value === item.key ? 'true' : 'false'"
            :aria-disabled="item.locked ? 'true' : null" :class="['lp-item', { picked: value === item.key, locked: item.locked }]" @click="$emit('pick', item)">
      <span :class="['lp-thumb', item.key]" aria-hidden="true">
        <i></i><i></i><i></i><i></i>
      </span>
      <span class="lp-name">{{ item.name }}<PlanChip v-if="item.locked" :plan="lockPlan" /></span>
      <span class="pb-muted">{{ item.note }}</span>
    </button>
  </div>
</template>

<script>
export const LAYOUTS = [
  { key: 'grid', name: 'Grid', note: 'A masonry wall of cards' },
  { key: 'cards', name: 'Cards', note: 'A sideways-scrolling row' },
  { key: 'carousel', name: 'Carousel', note: 'One at a time, with arrows' },
  { key: 'quote', name: 'Quote', note: 'One large quote' }
];

import PlanChip from './PlanChip.vue';

export default {
  name: 'LayoutPicker',
  components: { PlanChip },
  props: {
    value: { type: String, default: 'grid' },
    allowed: { type: Array, default: () => ['grid'] },
    label: { type: String, default: 'Layout' }
  },
  computed: {
    items() { return LAYOUTS.map(item => Object.assign({}, item, { locked: this.allowed.indexOf(item.key) < 0 })); },
    // The plan with every layout (the workspace's plan matrix).
    lockPlan() { return this.$store.getters['praiseboard/availableOn']('layouts') || ''; }
  }
};
</script>

<style scoped>
.lp{display:grid;grid-template-columns:repeat(auto-fill,minmax(min(150px,100%),1fr));gap:10px}
.lp-item{display:flex;flex-direction:column;align-items:stretch;gap:6px;text-align:left;padding:12px;border:1.5px solid #E6DED2;border-radius:12px;background:#fff;cursor:pointer}
.lp-item:hover{border-color:#D4C9B8}
.lp-item.picked{border-color:#B4472B;box-shadow:0 0 0 3px rgba(180,71,43,.15)}
.lp-item.locked{background:#FBF8F3}
.lp-name{display:flex;flex-wrap:wrap;justify-content:space-between;align-items:center;gap:4px;font:700 14px var(--font-body);color:#1F2328}
.lp-thumb{position:relative;display:grid;height:64px;padding:8px;border-radius:8px;background:#F3EEE6;gap:5px}
.lp-thumb i{display:block;border-radius:4px;background:#fff;border:1px solid #E6DED2}
.lp-thumb.grid{grid-template-columns:1fr 1fr 1fr;grid-template-rows:1fr 1fr}
.lp-thumb.grid i:nth-child(1){grid-row:span 2}
.lp-thumb.cards{grid-template-columns:1fr 1fr 1fr .45fr;overflow:hidden}
.lp-thumb.cards i:nth-child(4){border-right:0;border-radius:4px 0 0 4px}
.lp-thumb.carousel{grid-template-columns:10px 1fr 10px;align-items:center}
.lp-thumb.carousel i:nth-child(1),.lp-thumb.carousel i:nth-child(3){height:10px;border-radius:50%;background:#D4C9B8;border:0}
.lp-thumb.carousel i:nth-child(2){height:100%}
.lp-thumb.carousel i:nth-child(4){display:none}
.lp-thumb.quote{grid-template-columns:1fr}
.lp-thumb.quote i{display:none}
.lp-thumb.quote i:first-child{display:block;position:relative}
.lp-thumb.quote i:first-child::before{content:'\201C';position:absolute;left:8px;top:-6px;font:600 34px/1 var(--font-display);color:rgba(180,71,43,.6)}
</style>
